import React from "react";

const LandingCard = ({ title, count, icon }) => {
  return (
    <div className="card lading-card">
      <div>
        <p className="text-muted mb-2">{title}</p>
        <h3 className="mb-0">{count}</h3>
      </div>
      <div className="icon">
        <i className={`bi bi-${icon}`}></i>
      </div>
    </div>
  );
};

export default LandingCard;
